/**
 *
 * @param {string} value - value from input
 * @return {number} value with percentage sign removed and converted to number
 *
 * Turn a percentage string into a decimal number of that percentage
 */
function deformatPercentage(value) {
  // dividng by 100 coerces the string into a number
  return value.replace('%', '').replace(/ /g, '') / 100;
}

export default deformatPercentage;



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/util/deformatPercentage.js